import { StrictMode, type ComponentType } from 'react'
import { createRoot } from 'react-dom/client'
import { resolveSurface, type Surface } from './app/surface'
import { initI18n } from './lib/i18n'
import './styles/fonts'
import './styles/index.css'

const surface = resolveSurface(window.location)
document.documentElement.dataset.surface = surface.kind
initI18n()

const loaders: Record<
  Surface['kind'],
  () => Promise<{ default: ComponentType<{ surface: never }> }>
> = {
  admin: () => import('./surfaces/admin/AdminApp'),
  store: () => import('./surfaces/store/StoreApp'),
}

const container = document.getElementById('root')
if (!container) throw new Error('Missing #root element')

void loaders[surface.kind]().then(({ default: App }) => {
  const Surface = App as ComponentType<{ surface: Surface }>
  createRoot(container).render(
    <StrictMode>
      <Surface surface={surface} />
    </StrictMode>,
  )
})
